import { render, staticRenderFns } from "./ProjectGridSlider.vue?vue&type=template&id=63155ae6&"
import script from "./ProjectGridSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectGridSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports